import React from 'react';
import Icon from '../../../components/AppIcon';

const SupportContactPanel = () => {
  const contactMethods = [
   {
      id: 'email',
      icon: 'Mail',
      title: 'Email',
      value: 'support@idverify.fr',
      description: 'Réponse sous 24h',
      action: () => window.location.href = 'mailto:support@idverify.fr'
    },
    {
      id: 'phone',
      icon: 'Phone',
      title: 'Téléphone',
      value: '+33 1 23 45 67 89',
      description: 'Lun-Ven 9h-18h',
      action: () => window.location.href = 'tel:+33123456789'
    },
    {
      id: 'chat',
      icon: 'MessageCircle',
      title: 'Chat en ligne',
      value: 'Disponible maintenant',
      description: 'Réponse immédiate',
      action: () => console.log('Open chat widget')
    }
  ];

  const faqItems = [
    {
      question: 'Combien de temps prend la vérification ?',
      answer: 'La vérification prend généralement 24 à 48 heures ouvrables.'
    },
    {
      question: 'Puis-je modifier mes informations après soumission ?',
      answer: 'Contactez notre support pour modifier vos informations avant la validation finale.'
    }
  ];

  return (
    <div className="bg-surface rounded-xl border border-border shadow-elevation-2 p-6">
      <div className="flex items-center mb-6">
        <Icon name="HelpCircle" size={24} color="#3B82F6" className="mr-3" />
        <h2 className="text-xl font-semibold text-text-primary font-inter">
          Besoin d'aide ?
        </h2>
      </div>

      {/* Contact Methods */}
      {/*<div className="mb-8">*/}
      {/*  <h3 className="text-base font-medium text-text-primary mb-4 font-inter">*/}
      {/*    Contactez notre support*/}
      {/*  </h3>*/}
      {/*  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">*/}
      {/*    {contactMethods.map((method) => (*/}
      {/*      <button*/}
      {/*        key={method.id}*/}
      {/*        onClick={method.action}*/}
      {/*        className="p-4 border border-border rounded-lg hover:border-primary hover:bg-primary-50 transition-smooth text-left focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"*/}
      {/*      >*/}
      {/*        <div className="flex items-center mb-2">*/}
      {/*          <Icon name={method.icon} size={20} color="#3B82F6" className="mr-2" />*/}
      {/*          <span className="text-sm font-medium text-text-primary font-inter">*/}
      {/*            {method.title}*/}
      {/*          </span>*/}
      {/*        </div>*/}
      {/*        <p className="text-sm font-medium text-primary mb-1 font-inter">*/}
      {/*          {method.value}*/}
      {/*        </p>*/}
      {/*        <p className="text-xs text-text-secondary font-inter">*/}
      {/*          {method.description}*/}
      {/*        </p>*/}
      {/*      </button>*/}
      {/*    ))}*/}
      {/*  </div>*/}
      {/*</div>*/}

      {/* FAQ Section */}
      <div>
        <h3 className="text-base font-medium text-text-primary mb-4 font-inter">
          Questions fréquentes
        </h3>
        <div className="space-y-4">
          {faqItems.map((item, index) => (
            <details key={index} className="group">
              <summary className="flex justify-between items-center cursor-pointer list-none p-4 rounded-lg bg-background hover:bg-primary-50 transition-smooth">
                <span className="text-sm font-medium text-text-primary font-inter">
                  {item.question}
                </span>
                <Icon name="ChevronDown" size={18} className="text-text-secondary group-open:rotate-180 transition-smooth" />
              </summary>
              <div className="p-4 pl-6 text-sm text-text-secondary font-inter">
                {item.answer}
              </div>
            </details>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SupportContactPanel;